"use strict";
var buttons = document.querySelector(".container");
var table = document.querySelector(".field");
buttons.addEventListener("click", function(e) {
    var countCell = function countCell() {
        var rowCount = table.rows.length;
        var colCount = table.rows[0].cells.length;
        document.querySelector(".append-row").disabled = rowCount >= 10;
        document.querySelector(".remove-row").disabled = rowCount <= 2;
        document.querySelector(".append-column").disabled = colCount >= 10;
        document.querySelector(".remove-column").disabled = colCount <= 2;
    };
    var btn = e.target;
    if (btn.classList.contains("append-column")) {
        Array.from(table.rows).forEach(function(row) {
            return row.insertCell(-1);
        });
        countCell();
    }
    if (btn.classList.contains("remove-column")) {
        Array.from(table.rows).forEach(function(row) {
            return row.deleteCell(-1);
        });
        countCell();
    }
    if (btn.classList.contains("append-row")) {
        var cellsCount = table.rows[0].cells.length;
        var newRow = table.insertRow(-1);
        for(var i = 0; i < cellsCount; i++)newRow.insertCell(-1);
        countCell();
    }
    if (btn.classList.contains("remove-row")) {
        table.deleteRow(-1);
        countCell();
    }
});

//# sourceMappingURL=index.7ffbda62.js.map
